import type { ComponentPropsWithoutRef } from 'react'

// SelectModalDialogがaria-labelledbyで参照する。モーダルは同時に1つしか開かないため固定値でよい
export const MODAL_TITLE_ID = 'select-modal-title'

const ModalTitle = ({ className = '', ...props }: ComponentPropsWithoutRef<'h2'>) => (
  <h2 id={MODAL_TITLE_ID} className={`text-xl font-bold ${className}`} {...props} />
)

export default ModalTitle
